import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { CurrencyBadge } from '@/components/CurrencyBadge'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

export function ConvertReviewScreen() {
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)

  return (
    <>
      <PageHeader
        title="Confirm the conversion"
        subtitle="The rate below is held for 30 seconds. Nothing moves until you confirm."
        actions={
          <Button variant="ghost" size="md" iconStart="arrow_back" to="/convert">
            Change the amount
          </Button>
        }
      />

      <div className={checkout.grid}>
        <Card tone="light">
          <Stack gap={5}>
            <Stack direction="row" align="center" gap={4}>
              <CurrencyBadge currency="USD" size={44} />
              <Stack grow gap={0}>
                <Text variant="eyebrow" tone="secondary">
                  From
                </Text>
                <Text variant="subtitle" weight="bold" numeric>
                  $5,000.00
                </Text>
                <Text variant="eyebrow" tone="secondary">
                  US Dollar account · ••4568
                </Text>
              </Stack>
            </Stack>

            <Stack align="center">
              <Icon name="south" size={20} />
            </Stack>

            <Stack direction="row" align="center" gap={4}>
              <CurrencyBadge currency="EUR" size={44} />
              <Stack grow gap={0}>
                <Text variant="eyebrow" tone="secondary">
                  To
                </Text>
                <Text variant="subtitle" weight="bold" numeric>
                  €4,601.70
                </Text>
                <Text variant="eyebrow" tone="secondary">
                  Euro account · ••2231
                </Text>
              </Stack>
            </Stack>
          </Stack>
        </Card>

        <Stack gap={3} className={checkout.summary}>
          <Card tone="dark">
            <Card.Header>
              <Text variant="caption" weight="semibold" tone="onDark">
                What it costs
              </Text>
              <Pill tone="accent">Rate held 30s</Pill>
            </Card.Header>
            <Stack gap={0} className="pb-mt-3">
              {[
                ['Rate', '1 USD = 0.9203 EUR'],
                ['Spread · 0.6%', '$30.00'],
                ['Conversion fee', 'None'],
                ['Arrives', 'Instantly'],
              ].map(([label, value], index) => (
                <div key={label} className={checkout.line}>
                  <Text variant="caption" tone="onDarkMuted">
                    {label}
                  </Text>
                  <Text
                    variant="caption"
                    weight="semibold"
                    tone={index === 2 ? 'accent' : 'onDark'}
                    numeric
                  >
                    {value}
                  </Text>
                </div>
              ))}
            </Stack>
            <Card.Footer>
              <Button
                size="lg"
                block
                iconStart="lock"
                disabled={busy}
                onClick={() => {
                  setBusy(true)
                  window.setTimeout(() => navigate('/convert/done', { replace: true }), 500)
                }}
              >
                {busy ? 'Converting…' : 'Convert $5,000.00'}
              </Button>
            </Card.Footer>
          </Card>
        </Stack>
      </div>
    </>
  )
}
